import React, { Component } from 'react';
import TextField from '../TextField/TextField';
import CancelHelpLink from '../TextField/CancelHelpLink';
import _ from 'lodash';
import styles from './ClickToEditTextFieldStyles';
import FontIcon from 'material-ui/FontIcon';
import { KEYS } from 'crazyEditor/core/constants/editorConstants';
const stylesSCSS = require('./ClickToEditTextField.scss');


export default class ClickToEditTextField extends Component {
  constructor(props) {
    super(props);

    this.enterEditingMode = this.enterEditingMode.bind(this);
    this.exitEditingMode = this.exitEditingMode.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.state = {
      editMode: this.props.editMode || false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (_.isBoolean(nextProps.editMode)) {
      this.setState({
        editMode: nextProps.editMode
      });
    }
  }

  onKeyDown(event) {
    if (event.keyCode === KEYS.ESC) {
      this.exitEditingMode();
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  }

  getTextFieldStyles() {
    return _.assign({}, {
      style: styles.textFieldInputWrapper
    }, this.props.textFieldStyles || {});
  }

  getLabelStyles() {
    return _.assign({}, {
      labelWrapper: styles.labelWrapper,
      labelWrapperInner: styles.labelWrapperInner,
      labelWrapperInnerSpan: styles.labelWrapperInnerSpan,
      labelWrapperInnerFontIcon: styles.labelWrapperInnerFontIcon
    }, this.props.labelStyles || {});
  }

  getValue() {
    if (this.state.editMode) {
      return this.refs.textField.getValue();
    }
    const {value} = this.props;
    return value;
  }

  enterEditingMode() {
    this.setState({
      editMode: true
    });
  }

  exitEditingMode() {
    this.setState({
      editMode: false
    });
  }

  isEditing() {
    return this.state.editMode;
  }

  render() {
    const filteredTextFieldProps = _.omit(this.props, ['value', 'onKeyDown', 'textFieldStyles', 'labelStyles', 'editMode', 'defaultValue']);
    const textFieldStyles = this.getTextFieldStyles();
    const labelStyles = this.getLabelStyles();
    return (
      <span>
      {!this.isEditing() &&
      <div onClick={this.enterEditingMode}
           style={labelStyles.labelWrapper}
           className={stylesSCSS.labelWrapper}>
        <div style={labelStyles.labelWrapperInner}
             className={stylesSCSS.labelWrapperInner}>
                    <span style={labelStyles.labelWrapperInnerSpan}
                          className={stylesSCSS.labelWrapperInnerSpan}
                          title={this.props.value}>{this.props.value || this.props.defaultValue}
                    </span>
          <FontIcon style={labelStyles.labelWrapperInnerFontIcon}
                    className={`material-icons ${stylesSCSS.labelWrapperInnerFontIcon}`}>mode_edit</FontIcon>
        </div>
      </div>
      }
      {this.isEditing() &&
      <span>
        <TextField
          ref="textField"
          value={this.props.value}
          onKeyDown={this.onKeyDown}
          {...textFieldStyles}
          {...filteredTextFieldProps}
        />
        <CancelHelpLink onClick={this.exitEditingMode}/>
      </span>
      }
      </span>
    );
  }
}
